// extracted by mini-css-extract-plugin
export var leftAlign = "_3a-2";
export var popper = "_3a-0";
export var subtitle = "_3a-1";